import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NotificationService } from 'src/app/utils/notification.service';

@Component({
  selector: 'app-photo-upload',
  templateUrl: './photo-upload.component.html',
  styleUrls: ['./photo-upload.component.css'],
})
export class PhotoUploadComponent {
  @Input() label: string = 'Image';
  @Input() set value(v: string) {
    this._value = v;
    this.imageBroken = false;
    this.safeValue = v ? this.sanitizer.bypassSecurityTrustUrl(v) : null;
  }
  get value(): string {
    return this._value;
  }
  private _value: string = '';
  public safeValue: SafeUrl | null = null;

  @Input() disabled: boolean = false;
  @Input() accept: string = 'image/*';
  @Input() maxSizeMB: number = 2;
  @Input() highlightBorder: boolean = false;
  @Input() magnify: boolean = false;

  @Output() fileSelected = new EventEmitter<string>();
  @Output() fileRemoved = new EventEmitter<void>();

  public readonly placeholderSrc =
    '../../../../assets/images/aquila-placeholder.svg';
  public imageBroken: boolean = false;
  public showModal: boolean = false;

  constructor(
    private toastr: NotificationService,
    private sanitizer: DomSanitizer,
  ) {}

  public onChange(ev: any) {
    const file = ev?.target?.files?.[0];
    if (!file) return;
    if (file.size > this.maxSizeMB * 1024 * 1024) {
      this.toastr.error(`File should not exceed ${this.maxSizeMB}MB`);
      ev.target.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.fileSelected.emit(e.target.result);
      ev.target.value = '';
    };
    reader.readAsDataURL(file);
  }

  public onRemove(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    this.fileRemoved.emit();
  }

  public openModal(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    if (!this.value || this.imageBroken) return;
    this.showModal = true;
  }

  public closeModal() {
    this.showModal = false;
  }

  public onModalBackdropClick(ev: MouseEvent) {
    if (ev.target === ev.currentTarget) {
      this.closeModal();
    }
  }

  public onImageError() {
    this.imageBroken = true;
  }

  public handlePlaceholderError(ev: any) {
    ev.target.style.visibility = 'hidden';
  }
}
